import React from "react";
import { FiInfo, FiCircle, FiAlertTriangle, FiCheckCircle } from "react-icons/fi";

export const InfoSection = () => {
  return (
    <section className="flex flex-col gap-3" role="note" aria-label="Placement guidance">
      {/* Notice / helper */}
      <div className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3 text-amber-900">
        <FiInfo className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
        <p className="text-xs leading-5">
          <span className="font-semibold">Notice:</span>{" "}
          If you place an event on a <span className="font-medium">taken</span> position,
          it will override the current event at that slot. Tip: clicking the{" "}
          <span className="font-medium">current</span> slot again will clear it (leaves the slot empty).
        </p>
      </div>

      {/* Legend */}
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
        <LegendItem
          colorClasses="border-gray-200 bg-white text-gray-700"
          icon={<FiCircle className="h-4 w-4" aria-hidden="true" />}
          label="Position Empty"
        />
        <LegendItem
          colorClasses="border-red-200 bg-red-50 text-red-700"
          icon={<FiAlertTriangle className="h-4 w-4" aria-hidden="true" />}
          label="Taken by another event"
        />
        <LegendItem
          colorClasses="border-emerald-200 bg-emerald-50 text-emerald-700"
          icon={<FiCheckCircle className="h-4 w-4" aria-hidden="true" />}
          label="Current position of this event"
        />
      </div>
    </section>
  );
};

const LegendItem = ({ colorClasses, icon, label }) => (
  <div
    className={[
      "flex items-center gap-2 rounded-lg border px-3 py-2 text-xs font-medium shadow-sm",
      colorClasses,
    ].join(" ")}
  >
    {icon}
    <span className="capitalize">{label}</span>
  </div>
);

export default InfoSection;
